import React from "react";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="App">
      <Navbar />
      <Sidebar />
      <main
        className={`transition-all duration-500 lg:pt-[90px] pt-[60px] h-screen overflow-y-auto customScrollbarlg  lg:pl-[280px] md:pl-[220px] bg-gray-100  `}
      >
        <div className="lg:p-6 p-4 mb-16">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
